/**
 * Do not edit directly, this file was auto-generated.
 */

export const BreakpointMobile = "320";
export const BreakpointMobileXl = "480";
export const BreakpointTablet = "481";
export const BreakpointTabletXl = "768";
export const BreakpointLaptop = "769";
export const BreakpointLaptopXl = "1024";
export const BreakpointDesktop = "1025";
export const BreakpointDesktopXl = "1219";
export const BreakpointTv = "1220";
export const ColorDarkBg100 = "#000608";
export const ColorDarkBg80 = "#011217";
export const ColorDarkBg60 = "#011E26";
export const ColorDarkBg40 = "#012A35";
export const ColorDarkBg20 = "#023644";
export const ColorDarkBlack100 = "#000608";
export const ColorDarkBlack80 = "#001922";
export const ColorDarkBlack60 = "#002C3B";
export const ColorDarkContrast100 = "#FEFDF8";
export const ColorDarkContrast80 = "#FCFAEF";
export const ColorDarkContrast60 = "#FAF6E2";
export const ColorDarkContrast40 = "#F8F2D5";
export const ColorDarkContrast20 = "#F6EDC7";
export const ColorDarkError = "#E70D4F";
export const ColorDarkInfo = "#339AF0";
export const ColorDarkPrimary = "#FFBB00";
export const ColorDarkSecondary = "#15AF8D";
export const ColorDarkTertiary = "#15AF8D";
export const ColorDarkSuccess = "#14A38C";
export const ColorDarkWarning = "#EDB464";
export const ColorDarkWhite100 = "#FEFDF8";
export const ColorDarkWhite80 = "#FBF7E2";
export const ColorDarkWhite60 = "#F8F0CB";
export const ColorLightBg100 = "#FEFDF8";
export const ColorLightBg80 = "#FCFAEF";
export const ColorLightBg60 = "#FAF6E2";
export const ColorLightBg40 = "#F8F2D5";
export const ColorLightBg20 = "#F6EDC7";
export const ColorLightBlack100 = "#000608";
export const ColorLightBlack80 = "#001922";
export const ColorLightBlack60 = "#002C3B";
export const ColorLightContrast100 = "#000608";
export const ColorLightContrast80 = "#011217";
export const ColorLightContrast60 = "#011E26";
export const ColorLightContrast40 = "#012A35";
export const ColorLightContrast20 = "#023644";
export const ColorLightError = "#E70D4F";
export const ColorLightInfo = "#339AF0";
export const ColorLightPrimary = "#FFBB00";
export const ColorLightSecondary = "#15AF8D";
export const ColorLightTertiary = "#15AF8D";
export const ColorLightSuccess = "#14A38C";
export const ColorLightWarning = "#EDB464";
export const ColorLightWhite100 = "#FEFDF8";
export const ColorLightWhite80 = "#FBF7E2";
export const ColorLightWhite60 = "#F8F0CB";
